export default __webpack_public_path__ + "static/media/image2.367c24ca.png";